import { useMutation } from '@tanstack/react-query';

const submitData = async (data: string | undefined) => {
  try {
    const response = await fetch(data as string, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        'x-ms-blob-type': 'BlockBlob',
      },
    });
    return await response.json();
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useDeleteBlob = () => {
  return useMutation({
    mutationFn: submitData,
  });
};
